import { Component } from '@angular/core';
import { PrimeNGConfig, Translation } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'essb-ui-doctor';

  constructor(config: PrimeNGConfig,
    translateService: TranslateService) {
    translateService.get('primeng')
      .pipe(first())
      .subscribe((res: Translation): void => config.setTranslation(res));
  }
}
